import Moment from 'moment'

/**
 * Maps a portal language code to a Moment.js locale name.
 * Portal codes: 'E' = English, 'K' = Dansk, 'D' = Deutsch, 'V' = Svenska
 */
export function portalLanguageToMomentLocale(portalLanguageCode: string): string {
    switch (portalLanguageCode) {
        case 'K': return 'da'
        case 'D': return 'de'
        case 'V': return 'sv'
        default:  return 'en'
    }
}

/**
 * Returns a Kendo-compatible short date format string derived from the specified (or current) Moment locale.
 * E.g. for 'da': "DD.MM.YYYY" (Moment) → "dd.MM.yyyy" (Kendo)
 * E.g. for 'en': "MM/DD/YYYY" (Moment) → "MM/dd/yyyy" (Kendo)
 */
export function getKendoShortDateFormat(momentLocale?: string): string {
    const localeData = Moment.localeData(momentLocale ?? navigator.language)
    const momentFormat = localeData.longDateFormat('L')
    return momentFormat
        .replace('YYYY', 'yyyy')
        .replace('YY', 'yy')
        .replace('DD', 'dd')
}

/**
 * Returns a Kendo DateInput formatPlaceholder object that matches the locale's short date format,
 * so the placeholder reflects the expected input pattern (e.g. "dd.MM.åååå" for Danish, "MM/dd/yyyy" for English).
 */
export function getKendoDateFormatPlaceholder(momentLocale?: string): { day: string, month: string, year: string } {
    const locale = momentLocale ?? navigator.language
    const format = getKendoShortDateFormat(locale)
    const dayPart = format.match(/d+/)?.[0] ?? 'dd'
    const monthPart = format.match(/M+/)?.[0] ?? 'MM'
    const yearToken = format.match(/y+/)?.[0] ?? 'yyyy'
    // For Danish locale, substitute 'å' for 'y' (short for 'år' = year)
    const yearPart = locale.startsWith('da') ? yearToken.replace(/y/g, 'å') : yearToken
    return { day: dayPart, month: monthPart, year: yearPart }
}
